const config = {
  serverUrl: process.env.REACT_APP_SERVER_URL || 'https://server.lagodigardacamping.com/',
  sitoUrl: process.env.REACT_APP_SITO_URL || 'https://www.lagodigardacamping.com/',
}

export default config
